import neurotech from '../assets/Sanosh-intership.pdf'
import IHRD from '../assets/sanoshIHRD.pdf'
export const myresume_data = [
    {
      id: 1,
      type: "Education",
      stream: "Class XII",
      branch: "Computer Science",
      board: "State Board",
      school: "St.Augustine's HSS Aroor",
      percentage: "76%",
    },
    {
      id: 2,
      type: "Education",
      stream: "Polytechnic",
      branch: "Computer Science",
      board: "State Board Of Technical Education",
      School: "GPTC Cherthala",
      percentage: "9.25 CGPA",
    },
    {
      id: 3,
      type: "Education",
      stream: "Bachelor's Degree In Computer Science",
      branch: "Computer Science",
      board: "KTU",
      school: "Govt. Model Engineering College",
      percentage: "8 CGPA",
    },
  ];
  
  export const intership = [
    {
      id: 4,
      type: "internship",
      Company: "Codehall",
      Role: "Software Engineer intern",
      date: "August 2024",
    
    },
    {
      id: 5,
      type: "internship",
      Company: "Neuro Tech Pvt Ltd",
      Role: "SDE intern",
      date: "May-2023",
      certificate:neurotech
    },
    {
      id: 6,
      type: "internship",
      Company: "Labour Commissionerate Government of Kerala",
      Role: "Full Stack Developer",
      date: "April-2023",
      certificate:IHRD
    },
  ];

  export const fulltime = [
    {
      id: 7,
      type: "fulltime",
      Company: "Rootflo",
      Role: "Software Engineer",
      date: "2024 - Present",
    },
  ];
  